/**
 * check is array
 * @param value - value
 * @return boolean
 */
export const isArray = (value: any) => Array.isArray(value);

/**
 * check is object
 * @param value - value
 * @return boolean
 */
export const isObject = (value: any) => value !== null && typeof value === 'object';

/**
 * check is number
 * @param value - value
 * @return boolean
 */
export const isNumber = (value: any) => typeof value === 'number';

/**
 * check is string
 * @param value
 */
export const isString = (value: any) => typeof value === 'string';

/**
 * check is null
 * @param value - value
 * @return boolean
 */
export const isNull = (value: any) => value === null;

/**
 * check is undefined
 * @param value - value
 * @return boolean
 */
export const isUndefined = (value: any) => value === undefined;

/**
 * check is null or undefined
 * @param value - value
 * @return boolean
 */
export const isNil = (value: any) => value === null || value === undefined;

/**
 * check is empty object
 * @param obj - object value
 * @return boolean
 */
export const isEmptyObject = (obj: any): boolean => JSON.stringify(obj) === '{}';

/**
 * Checks if the value is an array of objects
 * @param value - value to check
 * @returns boolean - returns true if the value is an array containing only objects (not arrays and not null)
 */
export const isObjectArray = (value: unknown[]): boolean => {
  return Array.isArray(value) && value.every((item) => typeof item === 'object' && item !== null && !Array.isArray(item));
};

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

/**
 * check is a canonical GUID string
 * @param value - value
 * @return boolean
 */
export const isGuid = (value: unknown): value is string =>
  typeof value === 'string' && value !== EMPTY_GUID && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
